export default function (event) {
    event.stopPropagation();
}
